import { render, staticRenderFns } from "./SearchUser.vue?vue&type=template&id=4e67d286"
import script from "./SearchUser.vue?vue&type=script&lang=js"
export * from "./SearchUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports